import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'dss-portal-create-client',
  imports: [RouterOutlet],
  templateUrl: './create-client.component.html',
  styleUrl: './create-client.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateClientComponent {}
